<template>
  <v-container fluid>
    <v-sheet :height="height" class="overflow-y-auto">
      <slot name="top">
      </slot>
      <v-data-iterator
          :items="itemList"
          :items-per-page="-1"
          hide-default-footer
          no-data-text=""
      >
        <template v-slot:default="{ items, isExpanded, expand }">
          <v-row no-gutters class="flex-nowrap">
            <draggable :list="itemList" group="task_card" class="row" :disabled="disableDrag">
              <v-col :xl="xl" :lg="lg" :md="md" :sm="sm" :xs="xs" v-for="[index,item] in items.entries()" :key="index"
                     v-if="item.deleted === false || showDeleted" class="py-0 my-2">
                <slot name="default" :item="item" :index="index" :common="common" class="row">
                  <v-sheet outlined :color="getCardColor({item: item, index: index})" elevation="0" rounded>
                    <v-card elevation="0" class="mx-0 my-0"
                            :color="getCardColor({item: item, index: index})"
                    >
                      <slot name="bar" :item="item" :index="index" :common="common">
                        <v-toolbar :height="systemBarHeight" :color="getCardTitleColor({item: item, index: index})" tile
                                   outlined elevation="0"
                        >
                          <slot name="bar.index" :item="item" :index="index" :common="common">
                            <v-chip
                                small
                                outlined
                                class="font-weight-bold ml-n3 mr-0"
                                :color="getItemIndexColor(item)"
                                v-if="showIndex"
                            >{{ index + 1 }}
                            </v-chip>
                            <v-col cols="10" v-if="tabs(item).length > 0">
                              <v-chip-group
                                  v-model="tabsPoint[index]"
                                  mandatory
                                  active-class="active-tab"
                                  center-active
                                  v-if="!!tabsPoint"
                              >
                                <v-chip
                                    v-for="(tab, tabindex) in tabs(item)"
                                    :key="tabindex"
                                    small
                                    outlined
                                    label
                                    ripple
                                    :color="getTabColor(item, tabindex)"
                                    class="common-tab"
                                >
                                  {{ tab }}
                                </v-chip>
                              </v-chip-group>
                            </v-col>
                          </slot>
                          <slot name="bar.left" :item="item" :index="index" :common="common"
                                :setTabsPoint="setTabsPoint">
                          </slot>
                          <slot name="bar.center" :item="item" :index="index" :common="common">
                          </slot>
                          <slot name="bar.right" :item="item" :index="index" :common="common">
                            <v-spacer></v-spacer>
                          </slot>
                          <slot name="bar.end" :item="item" :index="index" :common="common">
                            <BaseDeleteIcon v-model="item.deleted" :readonly="disableItemEdit(item)"></BaseDeleteIcon>
                          </slot>
                        </v-toolbar>
                      </slot>
                      <slot name="body" :item="item" :index="index" :common="common">
                        <slot name="body.tabs" :item="item" :index="index" :common="common"
                              :tabindex="tabsPoint[index]">
                        </slot>
                      </slot>
                    </v-card>
                  </v-sheet>
                </slot>
              </v-col>
            </draggable>
          </v-row>
        </template>
        <template v-slot:footer="{ footer }">
          <v-row>
            <v-icon
                v-if="enableAddRow()"
                @click="addRow()"
                color="blue-grey lighten-2"
                class="ml-3 mt-2"
            >
              mdi-plus-box-outline
            </v-icon>
            <v-spacer></v-spacer>
          </v-row>
        </template>
      </v-data-iterator>
    </v-sheet>
  </v-container>
</template>

<script>
import commonFunction from '@/commonFunction/commonFunction'
import {v4 as uuidv4} from "uuid";
import draggable from "vuedraggable";
import BaseDeleteIcon from "@/components/Base/BaseDeleteIcon";

export default {
  name: 'BaseCardList',
  props: {
    height: {type: [Number], default: window.innerHeight},
    systemBarHeight: {type: [Number], default: 36},
    itemList: {default: () => []},
    editedItem: {default: () => []},
    common: {default: () => {}},
    defaultItem: {type: [Object], default: null},
    correctDefaultItem: {type: [Function], default: () => null},
    enableAddRow: {type: [Function], default: () => true},
    deleteRestoreEvent: {type: [Function], default: () => true},
    getCardColor: {type: [Function], default: () => null},
    getCardTitleColor: {type: [Function], default: () => null},
    getTabColor: {type: [Function], default: () => null},
    getItemIndexColor: {type: [Function], default: () => null},
    xl: {type: [String], default: "3"},
    lg: {type: [String], default: "3"},
    md: {type: [String], default: "4"},
    sm: {type: [String], default: "6"},
    xs: {type: [String], default: "6"},
    disableDrag: {type: [Boolean], default: false},
    disableItemEdit: {type: [Function], default: () => false},
    showDeleted: {type: [Boolean], default: true},
    tabs: {
      type: [Function], default: function (item) {
        return []
      }
    },
    defaultTab: {type: [Number], default: -1},
    defaultTabAfterAdd: {type: [Number], default: 0},
    showIndex: {type: [Boolean], default: true},
    newItemName: {type: [String], default: null},
  },

  components: {
    draggable,
    BaseDeleteIcon,
  },

  computed: {},

  watch: {
    itemList: {
      handler(newValue, oldValue) {
        // console.log('watch')
        this.emitValue()
      },
      deep: true
    }
  },

  methods: {

    addRow() {
      console.log('addRow', this.newItem)
      this.newItem = JSON.parse(JSON.stringify(this.defaultItem))
      this.correctDefaultItem(this.newItem)
      this.newItem.uid = uuidv4()
      if (!this.itemList)
        this.itemList = []
      this.itemList.push(JSON.parse(JSON.stringify(this.newItem)))
      this.tabsPoint[this.itemList.length - 1] = this.defaultTabAfterAdd
      this.emitValue()
    },

    emitValue() {
      // console.log('emitValue')
      this.$emit('update:itemList', this.itemList)
    },

    deleteItem(item) {
      if (item.hasOwnProperty('id') && item.id != null)
        item.deleted = true
      else {
        let index = this.itemList.indexOf(item)
        this.itemList.splice(index, 1)
      }
      this.emitValue()
      this.deleteRestoreEvent()
    },

    restoreItem(item) {
      item.deleted = false
      this.emitValue()
      this.deleteRestoreEvent()
    },

    setTabForAll(index) {
      this.tabsPoint = new Array(100).fill(index)
    },
    onOpened() {
      if (this.opened === true)
        this.setTabForAll(this.defaultTabAfterAdd)
      else
        this.setTabForAll(this.defaultTab)
    },

    setTabsPoint(index, tab) {
      this.tabsPoint[index] = tab
      console.log('setTabsPoint', index, this.tabsPoint[index])
    },

  },

  mounted() {
    this.newItem = JSON.parse(JSON.stringify(this.defaultItem))
    this.setTabForAll(this.defaultTab)
  },

  data() {
    return {
      newItem: {},
      tabsPoint: null,
      opened: false,
    }
  }
}
</script>

<style scoped lang="scss">
.bg-active {
  background-color: black;
  color: white !important;
}

.common-tab {
  border-top-width: thin;
  border-right-width: thin;
  border-bottom-width: thin;
  border-left-width: thin;
  border-top-style: none !important;
  border-right-style: none !important;
  border-bottom-style: none !important;
  border-left-style: none !important;
}

.active-tab {
  border-top-width: thin;
  border-right-width: thin;
  border-bottom-width: 2px !important;
  border-left-width: thin;
  border-top-style: none !important;
  border-right-style: none !important;
  border-bottom-style: solid !important;
  border-left-style: none !important;
  border-radius: 0 !important;
}

</style>

